import React from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const location = useLocation();
  const isSiteView = /\/sites\/\d+/.test(location.pathname);

  return (
    <>
      <TopBar />
      <div className="main-content">
        {isSiteView ? (
          <div className="site-view">
            <Sidebar />
            <div className="site-content">{children}</div>
          </div>
        ) : (
          <div className="portfolio-view">{children}</div>
        )}
      </div>
    </>
  );
}
